import { get } from '../client/axiosClient';
import { countryEndpoints } from '../endpoints/country.endpoints';
import type { ApiResponse, Country } from '../types';

class CountryService {
  async getAll(): Promise<ApiResponse<Country[]>> {
    const response = await get<any>(countryEndpoints.list());
    const raw = response.data;
    return { success: raw?.success ?? false, message: raw?.message, data: raw?.data ?? [] };
  }
}

export const countryService = new CountryService();
export default countryService;
